import { render, staticRenderFns } from "./UserCalendar.vue?vue&type=template&id=d7202c00&scoped=true&"
import script from "./UserCalendar.vue?vue&type=script&lang=js&"
export * from "./UserCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7202c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCalendar,VSheet})
